import { THREAD_FETCH, THREAD_SUCCESS, THREAD_FAILURE, THREAD_RESET } from '../actions/ThreadviewActions';
import { THREAD_FOLLOWING } from '../actions/ForumviewActions';
import { LOADING_BEHAVIOR } from '../actions/InfiniteScrollActions';
import merge from 'lodash/merge';
import union from 'lodash/union';

const initialState = {
	isFetching: false,
	loaded: false,
	lastError: '',
	entities: {},
	pages: [],
	result: {
		posts: [],
		topics: [],
		users: [],
		polls: [],
		pollOptions: [],
		poleVotes: []
	},
	threadId: null,
	postid: null
};

export default function threadview(prevState = initialState, action) {
	switch (action.type) {
		case THREAD_FETCH:
			return Object.assign({},
				prevState,
				{
					isFetching: true,
					// Only set loaded to false if we are doing a full refresh
					loaded: !( action.thread.loadingBehavior === LOADING_BEHAVIOR.REFRESH )
				});

		case THREAD_SUCCESS:
			let pageId = action.data.page === null ? 1 : parseInt( action.data.page );

			if (prevState.threadId !== action.thread.id || action.thread.loadingBehavior === LOADING_BEHAVIOR.REFRESH) {
				return merge(
					{},
					action.data,
					{
						isFetching: false,
						loaded: true,
						threadId: action.thread.id,
						pages: [parseInt( action.data.page )]
					}
				);

			} else {
				let postsResult, usersResult,pages;

				if(action.thread.loadingBehavior === LOADING_BEHAVIOR.PREPEND) {
					postsResult = [...action.data.result.posts, ...prevState.result.posts];
					usersResult = union(action.data.result.users, prevState.result.users);
					pages = [pageId,...prevState.pages];
				} else if(action.thread.loadingBehavior === LOADING_BEHAVIOR.APPEND) {
					postsResult = [...prevState.result.posts, ...action.data.result.posts];
					usersResult = union(prevState.result.users, action.data.result.users);
					pages = [...prevState.pages, pageId];
				}

				return merge(
					{},
					prevState,
					{ postid: null }, // note: this line can be removed when vb 1.8.04 is released
					action.data,
					{
						isFetching: false,
						loaded: true
					},
					{
						pages: pages,
						result: {
							posts: postsResult,
							users: usersResult
						}
					}
				);
			}

		case THREAD_FAILURE:
			return Object.assign({}, prevState, {
				lastError: action.error
			});

		case THREAD_RESET:
			return initialState;

		case THREAD_FOLLOWING:
			let prevEntitiesThread = {}, thread = {}, entities = '';
			if( prevState.entities.topics && prevState.entities.topics[ action.threadId ] ) {
				entities = 'topics';
			} else if( prevState.entities.sticky && prevState.entities.sticky[ action.threadId ] ) {
				entities = 'sticky';
			} else {
				return prevState;
			}

			prevEntitiesThread = prevState.entities[ entities ];
			thread = prevState.entities[ entities ][ action.threadId ];

			thread.isSubscribed = action.follow;
			let entitiesThreads = {
				[ entities ]: Object.assign( {}, prevEntitiesThread, { [ action.threadId ]: thread } )
			};
			return Object.assign( {}, prevState, entitiesThreads );

		default:
			return prevState;
	}
}




// WEBPACK FOOTER //
// ./common/reducers/threadview.js